var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axiosInstance from '../../store/AxiosSingleton';
import { Membre } from 'membre/classes/Membre.class';
import { Sortie } from 'sortie/classes/Sortie.class';
export class SortieService {
    /**
     * Sauvegarde la sortie
     * @param sortie Sortie à sauvegarder
     * @return Identifiant de la sortie sauvegardée, -1 si échoué
     */
    static saveSortie(sortie) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data: { content }, } = yield axiosInstance.post('/index.php', {
                    sortie: sortie.toRaw(),
                }, {
                    params: {
                        rub: SortieService.rubModule,
                        action: 'SAVE_SORTIE',
                    },
                });
                return content;
            }
            catch (_a) {
                return -1;
            }
        });
    }
    /**
     * Supprime une sortie
     * @param idSortie Identifiant de la sortie à supprimer
     * @param idRaisonSuppression Identifiant de la raison de la suppression (optionnel)
     * @param commentaireSuppression Commentaire sur le suppression (optionnel)
     * @return True si la suppression a réussi, false sinon
     */
    static deleteSortie(idSortie, idRaisonSuppression, commentaireSuppression) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'DELETE_SORTIE',
                    idSortie,
                    idRaisonSuppression,
                    commentaireSuppression,
                },
            });
            return content;
        });
    }
    /**
     * Suppression des photos d'une sortie
     * @param sortieImages Liste des images à supprimer
     * @return True si la suppression a réussi, false sinon
     */
    static deleteSortieImages(sortieImages) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'DELETE_SORTIE_IMAGES',
                    sortieImages,
                },
            });
            return content;
        });
    }
    /**
     * Charges les sorties qu'organise un membre
     * @param req Les paramètres de la requête
     * @return Toutes les sorties auxquels participe un membre et le nombre total
     */
    static loadAllOutGoingsFromMember(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: SortieService.rubModule, action: 'LOAD_ALL_OUTGOINGS_FROM_MEMBER' }, request),
            });
            return {
                sorties: content.sorties.map((sortieRow) => new Sortie(sortieRow)),
                total: content.total,
            };
        });
    }
    /**
     * Sauvegarde des images d'une sortie
     * @param sortieImages Liste des images à sauvegarder
     * @return True si la sauvegarde a réussi, false sinon
     */
    static saveSortieImages(sortieImages) {
        return __awaiter(this, void 0, void 0, function* () {
            if ((sortieImages === null || sortieImages === void 0 ? void 0 : sortieImages.length) === 0) {
                return false;
            }
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                sortieImages: sortieImages.map((sortieImage) => sortieImage.toRaw()),
            }, {
                params: {
                    rub: SortieService.rubModule,
                    action: 'SAVE_SORTIE_IMAGES',
                },
            });
            return content;
        });
    }
    /**
     * Ajout d'un participant à une sortie
     * @param idSortie Identifiant de la sortie
     * @return True si l'ajout a réussi, false sinon
     */
    static addSortieParticipant(idSortie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idSortie }, {
                params: {
                    rub: SortieService.rubModule,
                    action: 'ADD_SORTIE_PARTICIPANT',
                },
            });
            return content;
        });
    }
    /**
     * Suppression d'un participant à une sortie
     * @param idSortie Identifiant de la sortie
     * @return True si la suppression a réussi, false sinon
     */
    static removeSortieParticipant(idSortie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'REMOVE_SORTIE_PARTICIPANT',
                    idSortie,
                },
            });
            return content;
        });
    }
    /**
     * Charge les sorties en lien avec une autre
     * @param idSortie Identifiant de la sortie à partir de laquelle charger les autres
     * @return Les sorties en lien avec la sortie
     */
    static loadRelativeOutgoings(idSortie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'LOAD_RELATIVE_OUTGOINGS',
                    idSortie,
                },
            });
            return content.map((sortieRow) => new Sortie(sortieRow));
        });
    }
    /**
     * Vérification de la participation du membre connecté à une sortie
     * @param idSortie Identifiant de la sortie
     * @return True si le membre participe à la sortie, false sinon
     */
    static checkSortieParticipant(idSortie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'CHECK_SORTIE_PARTICIPANT',
                    idSortie,
                },
            });
            return content;
        });
    }
    /**
     * Charge les participants d'une sortie
     * @param request Paramètres de la requête
     * @return Les participants de la sortie
     */
    static loadSortieParticipants(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: SortieService.rubModule, action: 'LOAD_SORTIE_PARTICIPANTS' }, request),
            });
            return {
                membres: content.membres.map((membre) => new Membre(membre.infoPublic)),
                amount: content.amount,
            };
        });
    }
    /**
     * Chargement des sorties
     * @param requestData Paramètres de la requête
     * @return Les sorties et le nombre total
     */
    static loadSorties(requestData) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: SortieService.rubModule, action: 'LOAD_SORTIES' }, requestData),
            });
            return {
                sorties: content.sorties.map((sortieRow) => new Sortie(sortieRow)),
                total: content.total,
            };
        });
    }
    /**
     * Chargement des dernières sorties crées
     * @param amount Nombre de sorties à retourner
     * @return Les dernières sorties crées
     */
    static loadLastSorties(amount) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'LOAD_LAST_SORTIES',
                    amount,
                },
            });
            return content.map((sortieRow) => new Sortie(sortieRow));
        });
    }
    /**
     * Ajout d'une sortie dans les favoris de l'utilisateur
     * @param idSortie Identifiant de la sortie
     * @return True si l'ajout a réussi, false sinon
     */
    static addSortieFavorite(idSortie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idSortie }, {
                params: {
                    rub: SortieService.rubModule,
                    action: 'ADD_SORTIE_FAVORITE',
                },
            });
            return content;
        });
    }
    /**
     * Suppression d'une sortie dans les favoris de l'utilisateur
     * @param idSortie Identifiant de la sortie
     * @return True si la suppression a réussi, false sinon
     */
    static removeSortieFavorite(idSortie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'REMOVE_SORTIE_FAVORITE',
                    idSortie,
                },
            });
            return content;
        });
    }
    /**
     * Récupération du nombre total de sorties
     * @return Le nombre total de sorties
     */
    static loadSortiesAmount() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'LOAD_SORTIES_AMOUNT',
                },
            });
            return content;
        });
    }
    /**
     * Récupération d'une sortie à partir de son identifiant
     * @param idSortie Identifiant de la sortie
     */
    static loadSortieFromId(idSortie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'LOAD_SORTIE_FROM_ID',
                    idSortie,
                },
            });
            return new Sortie(content);
        });
    }
    /**
     * Récupération des centres d'intérêts qui sont présent dans le plus de sorties
     * @return Les centres d'intérêts les plus populaires
     */
    static loadTrendingCentresInteret() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'LOAD_TRENDING_CENTRES_INTERET',
                },
            });
            return content;
        });
    }
    /**
     * Récupération des catégories mises en avant
     * @return Les catégories mises en avant
     */
    static loadHighlightCategories() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'LOAD_HIGHLIGHT_CATEGORIES',
                },
            });
            return content;
        });
    }
    /**
     * Charge les sorties favorites d'un utilisateur
     * @param request Paramètres de la requête
     */
    static loadFavorite(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: SortieService.rubModule, action: 'LOAD_SORTIE_FAVORITE' }, request),
            });
            return {
                favorites: content.favorites.map((sortieRow) => new Sortie(sortieRow)),
                total: content.total,
            };
        });
    }
    /**
     * Charge le nombre de sorties non-modérées
     * @return Le nombre de sorties non-modérées
     */
    static loadUnmoderatedSortieAmount() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'LOAD_UNMODERATED_SORTIE_AMOUNT',
                },
            });
            return content;
        });
    }
}
SortieService.rubModule = 'sortie';
//# sourceMappingURL=data:application/json;base64,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